'use strict';

import { getJSON } from '../util';
import { queryFirst, addClass, removeClass } from '../domUtil';

const { getValidationMessage } = require('./../clientSideValidation').functions;
const invalidClass = 'is-invalid';
const checkBalanceForm = queryFirst('.gift-card-balance-check-form');
const feedbackMessageNode = queryFirst('.feedback-message', checkBalanceForm);
const balanceInfoEl = queryFirst('.balance-info', feedbackMessageNode);
const errorMessageNode = queryFirst('.gift-error-message', checkBalanceForm);
const checkBalanceBtn = queryFirst('.check-balance', checkBalanceForm);
const applyBtn = queryFirst('.apply-balance', checkBalanceForm);

let cardNumberInput;
let cardPinInput;

/**
 * Function to handle Gift card success senario
 * @param {string} response - Gift card response with success message and balance value
 */
function handleSuccess(response) {
    removeClass(cardNumberInput, invalidClass);
    removeClass(cardPinInput, invalidClass);

    const { successMessage, balance } = response.giftCertificate;
    errorMessageNode.innerHTML = '';
    if (successMessage && feedbackMessageNode) {
        balanceInfoEl.innerHTML = `${successMessage} <span class="value">${balance}</span>`;
    }
}

/**
 * Function to handle Gift card error senario
 * @param {string} errorResponse - Gift card error senario param
 */
function handleError(errorResponse) {
    addClass(cardNumberInput, invalidClass);
    addClass(cardPinInput, invalidClass);

    balanceInfoEl.innerHTML = '';
    if (errorResponse.error && feedbackMessageNode) {
        errorMessageNode.innerHTML = `<span class="error">${errorResponse.error}</span>`;
    }
}

/**
 * Function to validate gift card
 * @param {string} cardNumber - Gift card number
 * @param {string} cardPin - Gift card PIN
 */
function validateGiftCard(cardNumber, cardPin) {
    const { actionUrl } = checkBalanceForm.dataset;
    const csrfTokenInput = queryFirst('.csrf-token', checkBalanceForm);
    const spinner = $(checkBalanceForm).spinner();
    let csrfToken;

    if (csrfTokenInput) {
        csrfToken = csrfTokenInput.value;
    }

    const checkoutPage = document.getElementById('checkout-main');

    var $gcNumberInput = $('.gift-card-number input');

    let validForm = true;
    if ($gcNumberInput.val() === '') {
        validForm = false;
        $gcNumberInput.addClass('is-invalid');
        $gcNumberInput.siblings('.invalid-feedback').text($gcNumberInput.attr('data-missing-error'));
    }
    else {
        $gcNumberInput.removeClass('is-invalid');
        $gcNumberInput.siblings('.invalid-feedback').text($gcNumberInput.attr('data-card-error'));
    }

    if (validForm && actionUrl) {
        spinner.start();
        getJSON(
            actionUrl,
            'POST',
            {
                csrf_token: csrfToken,
                gcId: cardNumber,
                gcPin: cardPin,
                shortResponseMessage: !!checkoutPage
            },
            response => {
                if (response.error) {
                    handleError(response);
                } else {
                    handleSuccess(response);
                }
                spinner.stop();
            },
            error => {
                handleError(error);
                spinner.stop();
            }
        );
    }
}

/**
 * Function to handle form submit action
 *
 * @param {string} event - Event object
 */
function handleCheckBalanceClick(event) {
    event.preventDefault();
    validateGiftCard(cardNumberInput.value, cardPinInput.value);
}

/**
 * Function to clear error state
 *
 * @param {string} event - Event object
 */
function clearErrorState(event) {
    removeClass(event.target, invalidClass);

    if (errorMessageNode) {
        errorMessageNode.innerHTML = '';
    }
}

/**
 * On Input Event handler for Gift card Pin field
 * @param {string} event - Event object
 */
function onInputHandler(event) {
    clearErrorState(event);

    const inputEl = event.target;
    const currentLength = inputEl.value.length;
    const maxLength = parseInt(inputEl.getAttribute('maxlength'), 10);

    if (maxLength && currentLength > maxLength) {
        inputEl.value = inputEl.value.substring(0, maxLength);
    }
}

/**
 * Keydown event handler
 * @param {string} event - Event object
 * @returns {boolean} - returns event is cancelled or not
 */
function avoidExponentCharacter(event) {
    if (event.keyCode === 69) {
        event.preventDefault();
        return false;
    }
    if (event.keyCode === 13) {
        event.preventDefault();
        applyBtn.click();
        return false;
    }
    return true;
}

/**
 * Function to initialize events
 */
function initEvents() {
    cardNumberInput.addEventListener('keydown', avoidExponentCharacter);
    cardNumberInput.addEventListener('input', onInputHandler);

    cardPinInput.addEventListener('keydown', avoidExponentCharacter);
    cardPinInput.addEventListener('input', onInputHandler);

    checkBalanceBtn.addEventListener('click', _event => handleCheckBalanceClick(_event));

    const gcBalanceSection = queryFirst('.gift-card-balance-check-form')
    if(gcBalanceSection) {
        $('.gift-card-balance-check-form')
            .find('input, textarea')
            .on('blur', function () {
                if (this.validity.valid) {
                    removeClass(this, 'is-invalid');
                } else {
                    $(this)
                        .parents('.form-group, .input-group')
                        .find('.invalid-feedback')
                        .text(getValidationMessage.apply(this));
                }
            });
    }
}

if (checkBalanceForm) {
    cardNumberInput = queryFirst('.gift-card-number .form-control', checkBalanceForm);
    cardPinInput = queryFirst('.gift-card-pin .form-control', checkBalanceForm);

    if (cardNumberInput && cardPinInput) {
        initEvents();
    }
}

export default {
    initEvents: initEvents
};
